const genAnswer = function (qu, value, refItem) {
  value = value.split(',')
  return [{
    descId: qu.id,
    answer: value[0] || ''
  }]
}

const setAnswer = function (qu) {
  this.value = qu.answerList.length ? qu.answerList[0].answer : ''
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/TimeBox/answer.js